import cn from 'classnames'
import Image from 'next/image'
import {FC} from 'react'

import {useTranslation} from '@/i18n'
import {TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type TramaLogoProps = {
  variant?: 'white' | 'black'
  size?: 'medium' | 'small'
}

export const TramaLogo: FC<TramaLogoProps> = ({variant = 'black', size = 'medium'}) => {
  const {t} = useTranslation('page')
  const logoSrc = variant === 'white' ? '/images/logo-white.svg' : '/images/logo.svg'

  return (
    <>
      <div className={cn('image-wrapper', size)}>
        <Image
          src={logoSrc}
          alt={t('page-meta-title')}
          sizes={size === 'small' ? `78px` : `${TABLET_SCREENSIZE} 93px, 108px`}
          fill
          priority
          style={{objectFit: 'contain'}}
        />
      </div>

      <style jsx>{`
        .image-wrapper {
          display: block;
          position: relative;
          width: 108px;
          height: 30px;
        }
        .small {
          width: 78px;
          height: 20px;
        }
        @media ${TABLET_SCREENSIZE} {
          .image-wrapper {
            width: 93px;
            height: 24px;
          }
        }
      `}</style>
    </>
  )
}
